package com.kinoshazam.shared.`data`.db.sqldelight.shared

import `data`.db.delight.KinoshkaDbQueries
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.kinoshazam.shared.`data`.db.sqldelight.KinoshkaDb
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass

internal val KClass<KinoshkaDb>.schema: SqlSchema<QueryResult.AsyncValue<Unit>>
  get() = KinoshkaDbImpl.Schema

internal fun KClass<KinoshkaDb>.newInstance(driver: SqlDriver): KinoshkaDb = KinoshkaDbImpl(driver)

private class KinoshkaDbImpl(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver), KinoshkaDb {
  override val kinoshkaDbQueries: KinoshkaDbQueries = KinoshkaDbQueries(driver)

  public object Schema : SqlSchema<QueryResult.AsyncValue<Unit>> {
    override val version: Long
      get() = 2

    override fun create(driver: SqlDriver): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      driver.execute(null, """
          |CREATE TABLE FavoriteVideo(
          |id INTEGER PRIMARY KEY NOT NULL,
          |imdbId TEXT DEFAULT NULL,
          |imageUrl TEXT DEFAULT NULL,
          |title TEXT DEFAULT NULL,
          |isTvShow INTEGER NOT NULL,
          |isDeleted INTEGER NOT NULL,
          |changedAt TEXT
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE WatchProgress(
          |videoId INTEGER NOT NULL,
          |imdbId TEXT,
          |isTvShow INTEGER NOT NULL,
          |seasonNumber INTEGER NOT NULL,
          |episodeNumber INTEGER NOT NULL,
          |positionSec INTEGER NOT NULL,
          |durationSec INTEGER NOT NULL,
          |progress REAL NOT NULL,
          |engagedSec INTEGER NOT NULL,
          |status TEXT NOT NULL,
          |title TEXT,
          |imageUrl TEXT,
          |backdropUrl TEXT,
          |hiddenFromContinue INTEGER NOT NULL,
          |isDeleted INTEGER NOT NULL,
          |changedAt TEXT NOT NULL,
          |audio TEXT,
          |quality TEXT,
          |subtitles TEXT,
          |PRIMARY KEY(videoId, seasonNumber, episodeNumber)
          |)
          """.trimMargin(), 0).await()
    }

    private fun migrateInternal(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
    ): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      if (oldVersion <= 1 && newVersion > 1) {
        driver.execute(null, "ALTER TABLE WatchProgress ADD COLUMN audio TEXT", 0).await()
        driver.execute(null, "ALTER TABLE WatchProgress ADD COLUMN quality TEXT", 0).await()
        driver.execute(null, "ALTER TABLE WatchProgress ADD COLUMN subtitles TEXT", 0).await()
      }
      if (oldVersion <= 1 && newVersion > 1) {
        driver.execute(null, """
            |CREATE TABLE WatchProgress(
            |videoId INTEGER NOT NULL,
            |imdbId TEXT,
            |isTvShow INTEGER NOT NULL,
            |seasonNumber INTEGER NOT NULL,
            |episodeNumber INTEGER NOT NULL,
            |positionSec INTEGER NOT NULL,
            |durationSec INTEGER NOT NULL,
            |progress REAL NOT NULL,
            |engagedSec INTEGER NOT NULL,
            |status TEXT NOT NULL,
            |title TEXT,
            |imageUrl TEXT,
            |backdropUrl TEXT,
            |hiddenFromContinue INTEGER NOT NULL,
            |isDeleted INTEGER NOT NULL,
            |changedAt TEXT NOT NULL,
            |PRIMARY KEY(videoId, seasonNumber, episodeNumber)
            |)
            """.trimMargin(), 0).await()
      }
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      var lastVersion = oldVersion

      callbacks.filter { it.afterVersion in oldVersion until newVersion }
      .sortedBy { it.afterVersion }
      .forEach { callback ->
        migrateInternal(driver, oldVersion = lastVersion, newVersion = callback.afterVersion +
          1).await()
        callback.block(driver)
        lastVersion = callback.afterVersion + 1
      }

      if (lastVersion < newVersion) {
        migrateInternal(driver, lastVersion, newVersion).await()
      }
    }
  }
}
